export default __webpack_public_path__ + "static/media/playstore-s1.d30c874a.webp";